class List {
  static update(list, data, keyToCompare = 'id') {
    return list.map((item) => {
      if (item[keyToCompare] === data[keyToCompare]) {
        return data;
      }
      return item;
    });
  }

  static remove(list, data, keyToCompare = 'id') {
    for (let i = 0; i < list.length; i += 1) {
      if (parseInt(list[i][keyToCompare]) === parseInt(data[keyToCompare])) {
        list.splice(list.indexOf(list[i]), 1);
      }
    }
    return list;
  }

  static new(list, data) {
    list.unshift(data);
    return list;
  }
}

export default List;
